import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../components/editForm";
import { langCommon } from "../../locales";
import { CommonServer } from "./../../server";

const server = CommonServer.Mine;

const DEFAULT_OPERATION_DATA = {
    account: null,
    password: null,
    password2: null,
}

type OperateModeType = 'password' | 'account'

export const Operation = forwardRef((props: any, ref: any) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('password');


    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(server.modify, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(langCommon?.modifySuccess);
            changeVisible(false);
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return mode === 'account' ? [{
            title: '新账号',
            type: "input",
            field: "account",
            allowClear: true,
            rules: [{
                required: true,
                validator: async (rule: any, value: any) => {
                    console.log(value.length, 3333)
                    if (!value) {
                        return Promise.reject(`${langCommon?.pleaseInput}账号`);
                    } else if (value.length < 6) {
                        return Promise.reject(`账号长度不能小于5位`);
                    }
                    return Promise.resolve();
                }
            }]
        }] : [
            {
                title: '新密码',
                type: "input",
                extendType: 'Password',
                field: "password",
                allowClear: true,
                rules: [{
                    required: true,
                    validator: async (rule: any, value: any) => {
                        if (!value) {
                            return Promise.reject(`${langCommon?.pleaseInput}密码`);
                        } else if (value.length < 6) {
                            return Promise.reject(`密码长度不能小于6位`);
                        }
                        return Promise.resolve();
                    }
                }]
            },
            {
                title: '确认密码',
                type: "input",
                extendType: 'Password',
                field: "password2",
                allowClear: true,
                rules: [{
                    required: true,
                    validator: async (rule: any, value: any) => {
                        if (!value) {
                            return Promise.reject(`${langCommon?.pleaseInput}密码`);
                        } else if (value !== formData.password) {
                            return Promise.reject(`两次密码输入需一致`);
                        }
                        return Promise.resolve();
                    }
                }]
            },
        ];
    }, [formData, mode]);

    return (
        <div>
            <Modal
                title={mode === 'account' ? '修改账号' : '修改密码'}
                width={400}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    run(mode === 'account' ? { Account: formData.account } : { Password: formData.password })
                }}
            >
                <EditForm
                    componentId="mine-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 6 },
                        wrapperCol: { span: 18 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
            </Modal>
        </div>
    );
})
